module.exports = __webpack_public_path__ + "images/sign-up-for-free.png";